import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, CalendarClock } from "lucide-react";
import { scrollToId } from "@/components/landing/shared";

/**
 * Compact, repeatable call-to-action band inserted between landing sections.
 * variant="book"  -> routes to the paid booking flow (/prenota)
 * variant="lead"  -> scrolls to the qualifying form (#contatto)
 */
export default function InlineCTA({
  variant = "book",
  title,
  subtitle,
  cta,
  testid = "inline-cta",
}) {
  const isBook = variant === "book";
  const heading =
    title ||
    (isBook
      ? "Vuoi un confronto diretto sul tuo progetto?"
      : "Raccontami come lavora la tua azienda");
  const sub =
    subtitle ||
    "Posti consulenza limitati questo mese · seleziono massimo 4 progetti l'anno.";
  const label = cta || (isBook ? "Prenota la call" : "Richiedi un'analisi");

  return (
    <section className="relative py-8 sm:py-10">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.45 }}
          className="flex flex-col items-start gap-4 rounded-2xl border border-black/10 bg-white px-6 py-5 sm:flex-row sm:items-center sm:justify-between sm:px-8"
        >
          <div>
            <h3 className="font-display text-lg font-semibold tracking-tight text-[color:var(--text-primary)] sm:text-xl">
              {heading}
            </h3>
            <p className="mt-1.5 flex items-center gap-1.5 text-sm text-[color:var(--gold-600)]">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-[color:var(--gold-500)]" />
              {sub}
            </p>
          </div>

          {isBook ? (
            <Link
              to="/prenota"
              data-testid={testid}
              className="inline-flex h-11 shrink-0 items-center justify-center gap-2 rounded-xl bg-emerald-700 px-5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-emerald-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300 focus-visible:ring-offset-2"
            >
              <CalendarClock className="h-4 w-4" />
              {label}
            </Link>
          ) : (
            <button
              onClick={() => scrollToId("#contatto")}
              data-testid={testid}
              className="inline-flex h-11 shrink-0 items-center justify-center gap-2 rounded-xl bg-emerald-700 px-5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-emerald-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300 focus-visible:ring-offset-2"
            >
              {label}
              <ArrowRight className="h-4 w-4" />
            </button>
          )}
        </motion.div>
      </div>
    </section>
  );
}
